import React, { FC } from "react";
import Typography from "Components/DesignSystem/Typography/Typography";

interface CategoryTypeItemProps {
  categoryTypename: string;
  categoryTypeIndex: number;
}

/**
 * Group heading for one category type (§ 64): a real `h2` so the page keeps an
 * outline under the `h1` title, on `sub-title-label`/`ink-secondary` — the same
 * eyebrow PDW's category-type picker uses for the same data (§ 270; § 268 had tried
 * `heading-3`, and before that it was `title-header`) — in place of the legacy
 * raw-`slategray` div.
 *
 * § 268/§ 270 — `tw-mt-5` above, against the tile grid's `tw-mt-3` below. The heading
 * used to sit 12px under the previous group's tiles and 12px above its own,
 * equidistant from both, so proximity bound it to neither. 20/12 binds it to what it
 * labels, and matches PDW's own 20/12.
 */
const CategoryTypeItem: FC<CategoryTypeItemProps> = ({ categoryTypename, categoryTypeIndex }) => {
  return (
    /* § 270 — `sub-title-label` (12px/600), the EYEBROW, correcting § 268.
       
       § 268 moved this from `title-header` (14px) up to `heading-3` (16px) on the
       premise that a group heading must outrank the things it groups. That is a real
       typographic rule and it is not this system's. The design system's own grouping
       primitives — `Menu` and `Dropdown`, whose whole job is sectioning a list — label
       their sections with `sub-title-label`, and PDW's category-type picker
       (`Components/GMS/Pdw/CategoryRadioPicker.jsx`) labels THIS EXACT DATA with it
       too. A group label here is quieter and smaller than its contents; it works
       through size contrast and whitespace, not by outranking them.
       
       At 16/600 under an 18/500 page title it was 2px smaller and a weight heavier, so
       the group labels competed with the page's own title. Reported by eye, comparing
       this screen against PDW's.
       
       `as="h2"` is load-bearing and stays — MORE so now: `sub-title-label` defaults to
       a `span`, so dropping it costs the page its heading outline entirely rather than
       just skipping a level. */
    <Typography
      variant="sub-title-label"
      as="h2"
      id={`categories-type-${categoryTypeIndex}-header`}
      className="tw-mt-5 tw-text-ink-secondary"
    >
      {categoryTypename ?? "-"}
    </Typography>
  );
};

export default CategoryTypeItem;
